
const DisplayStatus = () => {
    return (
        <div>DisplayStatus</div>
    )
}

export default DisplayStatus